import {IEsgDataIds, IEsgFilters} from "./EsgDashboard.type";

// export const initialStateEsgFilters: IEsgFilters = {
//   cagr_tier: 0,
//   rank_tier: 0,
//   market_forecast_tier: 0,
// };

export const initialStateEsgFilters: IEsgFilters = {
  parametr_esg: {
    id: "rank_tier",
    turnOn: false,
  },
  value_esg: {
    id: "top25",
    turnOn: false,
  },
  // market_forecast_tier: 0,
};

export const initialStateEsgDataIds: IEsgDataIds = {
  directionId: null,
  directionName: "",
  projectId: null,
  projectName: "",
};
